import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { CadastroMedico, ConviteUsuario, Hospital, ICadastroMedicoMessage, Medico, Secretaria, TipoConviteEnum, TipoUsuarioEnum, UsuarioTipo } from '@/types/_'
import { Especialidade } from '@/types/interfaces/Especialidade'
import { SecretariaMedico } from '@/types/interfaces/CadastroMedico'

@Module({ namespaced: true, name: 'CadastroMedicoStore' })
export default class CadastroMedicoStore extends VuexModule {
  private cadastroMedicoDefault: CadastroMedico = {
    id: '',
    cpf: '',
    celular: '',
    conviteId: '',
    email: '',
    nome: '',
    sexo: '',
    hospitais: [],
    especialidades: [],
    assinatura: '',
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    secretarias: [],
    medicoRecebeNotificacoes: true,
    tipoConvite: null,
    localAtendimentoNome: '',
    loginCadastrado: false,
    termoAceite: {
      exibeTermo: false,
      termo: null,
    },
  }

  private secreatriaDefault: Secretaria = {
    nome: '',
    email: '',
    sexo: '',
    cpf: '',
    message: {
      cpf: '',
      email: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    },
  }

  private cadastroMedicoMessageDefault: ICadastroMedicoMessage = {
    assinatura: '',
    celular: '',
    cpf: '',
    dataNascimento: null,
    email: '',
    especialidades: '',
    hospitais: '',
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    nome: '',
    sexo: '',
    success: true,
    total: 0,
  }

  cadastroMedicoMessage: ICadastroMedicoMessage = { ...this.cadastroMedicoMessageDefault }

  public step: number = 1
  public cadastroMedico: CadastroMedico = { ...this.cadastroMedicoDefault }
  private secretariaDefault: Secretaria = {
    cpf: '',
    email: '',
    message: {
      cpf: '',
      email: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    },
    nome: '',
    sexo: '',
  }

  private secretariaMedicoDefault: SecretariaMedico = {
    assinarEnviar: null,
    email: '',
    mensagem: '',
    nome: '',
    assinarEnviarMensagem: '',
    nomeMensagem: '',
  }

  public secretariaMedico: SecretariaMedico = { ...this.secretariaMedicoDefault }
  public secretariasMedico: SecretariaMedico[] = [this.secretariaMedico]
  public secretaria: Secretaria = { ...this.secretariaDefault }
  public cadastroSecretarias: Secretaria[] = [this.secretaria]
  public especialidadesLista: Especialidade[] = []
  public hospitais: Hospital[] = []
  public conviteUsuarioParamsDefault: any = {
    conviteId: '',
    tipoConvite: '',
  }

  public conviteUsuarioParams: any = { ...this.conviteUsuarioParamsDefault }
  public cpfInicial: string = ''
  public currentStep: number = 1

  @Action
  async sendCadastroMedico(cadastroMedico: CadastroMedico) {
    const request = await Apis.Cadastro.CadastroApi.sendCadastroMedico(cadastroMedico)
    return request
  }

  @Action
  async getConviteUsuario() {
    const params: any = this.conviteUsuarioParams
    const request = await Apis.Cadastro.CadastroApi.getConviteUsuario(params)

    if (request.success) {
      this.context.commit('setConviteUsuario', request.data)
    }

    return request
  }

  @Action
  async getTermosAceites() {
    const params: any = {
      hospitais: this.cadastroMedico.hospitais.map(c => c.id),
    }
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getTermosAceites(params)

    if (request.success) {
      this.context.commit('setTermosAceites', request.data)
    }

    return request
  }

  @Action
  async generateQrCode(conviteId: string) {
    const request = await Apis.Cadastro.CadastroApi.generateQrCode(conviteId)

    if (request.success) {
      return request.data.qrCodeBase64
    }

    return ''
  }

  @Action
  async getCbosAll() {
    const request = await Apis.Cadastro.CadastroApi.getCbosAll()
    this.context.commit('setEspecialidades', request.data)
    return request
  }

  @Action
  async checkExists(cpf: string) {
    const request = await Apis.Cadastro.CadastroApi.checkExists(cpf)
    return request
  }

  @Action
  async checkExisteContaCadastrada(cpf: string) {
    const request = await Apis.Cadastro.CadastroApi.checkExisteContaCadastrada(cpf)
    return request
  }


  @Action
  async checkEmailExistente(email: string) {
    const request = await Apis.Cadastro.CadastroApi.checkExisteContaCadastradaPorEmail(email)
    return request
  }

  @Action
  async validaCpfExists(cpf: string) {
    const request = await Apis.Cadastro.CadastroApi.validaCpfExists(cpf)
    return request
  }

  @Action
  async verificaSeExistePreCadastroMedicoHospital(cpf: string) {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.verificaSeExistePreCadastroMedicoHospital(cpf)
    return request
  }

  @Action
  async uploadAssinatura(upload: any) {
    const request = await Apis.Cadastro.CadastroApi.uploadAssinatura(upload)
    return request
  }

  @Action
  async associarConta(params: any) {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.associarConta(params)
    return request
  }

  @Action
  async checkSecretariaCpf(cpf: string) {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.checkSecretariaCpf(cpf)
    return request
  }

  @Action
  async getUserTermsOfUse() {
    const queryParamsFilter = { tipo: 'TermoDeUso' }
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getUserTermsOfUse(queryParamsFilter)
    return request.data
  }

  @Mutation
  setCPFInicial(value: string) {
    this.cpfInicial = value
  }

  @Mutation
  setCurrentStep(value: number) {
    this.currentStep = value
  }

  @Mutation
  setConviteUsuario(conviteUsuario: ConviteUsuario) {
    this.cadastroMedico.conviteId = conviteUsuario.id
    this.cadastroMedico.nome = conviteUsuario.nome
    this.cadastroMedico.assinatura = conviteUsuario.assinatura
    this.cadastroMedico.localAtendimentoNome = conviteUsuario.localAtendimentoNome ? conviteUsuario.localAtendimentoNome : ''
    this.cadastroMedico.loginCadastrado = conviteUsuario.loginCadastrado
    this.cadastroMedico.hospitais = conviteUsuario.hospitais
    this.hospitais = conviteUsuario.hospitais

    if (conviteUsuario.cpf) {
      this.cadastroMedico.cpf = conviteUsuario.cpf
    }

    if (this.cadastroMedico.loginCadastrado) {
      this.cadastroMedico.email = conviteUsuario.login
    }
  }

  @Mutation
  setEspecialidades(especialidades: Especialidade[]) {
    this.especialidadesLista = especialidades
  }

  @Mutation
  setTermosAceites(values: any) {
    this.cadastroMedico.termoAceite = values
  }

  @Mutation
  setAssinatura(value: any) {
    this.cadastroMedico.assinatura = value
  }

  @Mutation
  setStep(value: number) {
    this.step = value
  }

  @Mutation
  setConviteUsuarioParams(value: any) {
    this.conviteUsuarioParams.conviteId = value.conviteId
    this.conviteUsuarioParams.tipoConvite = value.tipoConvite
  }

  @Mutation
  setCadastroMedicoMessage(message: ICadastroMedicoMessage) {
    this.cadastroMedicoMessage = message
  }

  @Mutation
  addCadastroSecretaria() {
    this.cadastroSecretarias.push({ ...this.secreatriaDefault })
  }

  @Mutation
  addCadastroSecretariaMedico() {
    this.secretariasMedico.push({ ...this.secretariaMedicoDefault })
  }

  @Mutation
  addSecretarias(secretarias: Secretaria[]) {
    this.cadastroSecretarias = secretarias
  }

  @Mutation
  addSecretaria(secretaria: Secretaria) {
    this.secretaria = secretaria
  }

  @Mutation
  removeSecretaria(value: number) {
    if (value >= 0) this.cadastroSecretarias.splice(value, 1)
  }

  @Mutation
  removeSecretariaMedico(value: number) {
    if (value >= 0) this.secretariasMedico.splice(value, 1)
  }

  @Mutation
  removeEspecialidades(item: any) {
    const removeArray: any[] = []
    for (let i = 0; i < this.cadastroMedico.especialidades.length; i++) {
      if (this.cadastroMedico.especialidades[i] === item.id) {
        removeArray.push(i)
      }
    }
    for (let i = 0; i < removeArray.length; i++) {
      this.cadastroMedico.especialidades.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeHospitais(item: any) {
    const removeArray: any[] = []
    for (let i = 0; i < this.cadastroMedico.hospitais.length; i++) {
      if (this.cadastroMedico.hospitais[i] === item.id) {
        removeArray.push(i)
      }
    }
    for (let i = 0; i < removeArray.length; i++) {
      this.cadastroMedico.hospitais.splice(removeArray[i], 1)
    }
  }

  @Mutation
  clearCadastroMedico() {
    this.cadastroMedico = { ...this.cadastroMedicoDefault }
  }

  @Mutation
  clearCadastroMedicoMessage() {
    this.cadastroMedicoMessage = { ...this.cadastroMedicoMessageDefault }
  }

  @Mutation
  clearSecretariaMedica() {
    this.secretariasMedico = [{ ...this.secretariaMedicoDefault }]
  }
}
